import api from './api';

/**
 * 获取腾讯IM的UserSig
 * @param {number} expireTime - 过期时间（秒），可选
 * @returns {Promise<{user_id: string, user_sig: string, expire_time: number}>}
 */
export const getUserSig = async () => {
  try {
    // 这里直接调用api.get，api会自动带上token
    const data = await api.get('/tencent-im/user-sig');
    return data;
  } catch (error) {
    throw error;
  }
};

const imService = {
  getUserSig,
};

export default imService; 